import { TOKEN_INFO } from '@/constants/user';
import { AuthTokenResponse, JwtPayload } from '@/services/api.types';

export type JWT = {
  header: { [key: string]: any };
  payload: JwtPayload;
  signature: string;
};

class Token {
  private tokenObject: JWT | null = null;

  saveAccessToken(token: string) {
    localStorage.setItem(TOKEN_INFO.ACCESS_TOKEN, token);
  }

  getAccessToken(): string {
    return localStorage.getItem(TOKEN_INFO.ACCESS_TOKEN) ?? '';
  }

  parseJwt(jwt: string): JWT {
    const split = jwt.split('.');
    return {
      header: JSON.parse(atob(split[0])),
      payload: JSON.parse(atob(split[1])),
      signature: split[2],
    };
  }

  saveRefreshToken(token: string) {
    localStorage.setItem(TOKEN_INFO.REFRESH_TOKEN, token);
  }

  getRefreshToken(): string {
    return localStorage.getItem(TOKEN_INFO.REFRESH_TOKEN) ?? '';
  }

  persistToken(tokens: Pick<AuthTokenResponse, 'access' | 'refresh'>) {
    this.saveAccessToken(tokens.access);
    this.saveRefreshToken(tokens.refresh);
  }
}

export default new Token();
